// data from here:
// https://nl.wikipedia.org/wiki/Schaal_van_Beaufort
export const meterPerSecondsToBeaufort = (mPerS: number): number => {
  if (mPerS < 0.3) {
    return 0;
  }
  if (mPerS < 1.6) {
    return 1;
  }
  if (mPerS < 3.4) {
    return 2;
  }
  if (mPerS < 5.5) {
    return 3;
  }
  if (mPerS < 8.0) {
    return 4;
  }
  if (mPerS < 10.8) {
    return 5;
  }
  if (mPerS < 13.9) {
    return 6;
  }
  if (mPerS < 17.2) {
    return 7;
  }
  if (mPerS < 20.8) {
    return 8;
  }
  if (mPerS < 24.5) {
    return 9;
  }
  if (mPerS < 28.5) {
    return 10;
  }
  if (mPerS < 32.7) {
    return 11;
  }
  if (mPerS >= 32.7) {
    return 12;
  }
  // next line should never happen
  return 12;
};

export const beaufortToMeterPerSeconds = (beaufort: number): number => {
  if (beaufort < 1) {
    return 0.2;
  }
  if (beaufort < 2) {
    return 0.9;
  }
  if (beaufort < 3) {
    return 2.45;
  }
  if (beaufort < 4) {
    return 4.4;
  }
  if (beaufort < 5) {
    return 6.7;
  }
  if (beaufort < 6) {
    return 9.35;
  }
  if (beaufort < 7) {
    return 12.3;
  }
  if (beaufort < 8) {
    return 15.5;
  }
  if (beaufort < 9) {
    return 18.95;
  }
  if (beaufort < 10) {
    return 22.6;
  }
  if (beaufort < 11) {
    return 26.45;
  }
  if (beaufort < 12) {
    return 31.05;
  }
  return 35; // windspeed 12
};
